export const formatElapsedTime = (timeInMin) => timeInMin ? `${Math.floor(timeInMin / 60)}h ${Math.floor(timeInMin % 60)}min` : '-';
export default formatElapsedTime;
//# sourceMappingURL=formatElapsedTime.js.map